class InitTrustMateWidgetFooter extends HTMLElement {
  constructor () {
    super();

    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', () => this.initTrustmate());
    } else {
      this.initTrustmate();
    }
  }

  initTrustmate () {
    const trustMateContainer = this.querySelector('.footer-newsletter-reviews-trustmate');

    if (!trustMateContainer || trustMateContainer.classList.contains('js-initialized')) {
      return;
    }

    const trustMateDiv = trustMateContainer.querySelector('.tm-dodo2');

    if (!trustMateDiv) {
      return setTimeout(this.initTrustmate.bind(this), 333);
    }

    trustMateContainer.classList.add('js-initialized');

    try {
      const rate = parseFloat(trustMateDiv.querySelector('.tm-dodo2__grade').textContent.trim());
      const logo = trustMateDiv.querySelector('.tm-dodo2__logo img').src;
      const reviews = parseInt(trustMateDiv.querySelector('[data-reviews]').dataset.reviews);

      if (Number.isNaN(rate) || Number.isNaN(reviews)) {
        throw Error('Rate/Reviews is NaN');
      }

      const container = this.querySelector('.footer-newsletter-reviews-container');
      container.querySelector('.footer-newsletter-reviews-rate').innerHTML = rate;
      container.querySelector('.footer-newsletter-reviews-logo').innerHTML = `<img src="${logo}" alt="Trustmate logo"/>`;
      container.querySelector('.footer-newsletter-reviews-count').innerHTML = reviews;
      container.style.display = '';
    } catch (e) {
      console.error('Failed to initialize trust mate in footer', e);
    }
  }
}

customElements.define('trustmate-widget-footer', InitTrustMateWidgetFooter)